import React from 'react';
import {
    Card,
    FormLayout,
    TextField,
    Text,
    Select
} from '@shopify/polaris';
    
export function AutoTagProductsByTypeSettings(props) {

    function onPrefixChange(value) {

        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.prefix = value;
        props.onSettingsChange(newSettings);
    }

    function onCasingTransformationChange(value) {
        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.casingTransformation = value;
        props.onSettingsChange(newSettings);
    }

    function onSpacesTransformationChange(value) {

        var newSettings = JSON.parse(JSON.stringify(props.settings));
        newSettings.spacesTransformation = value;
        props.onSettingsChange(newSettings);
    }

    return (
        <React.Fragment>

            <Card.Section title="State Tags">
                <Text variant="bodyMd" as="p" color="warning">
                    Note: tags for previous states are cleared when product enters in new state.
                </Text>
                <br />
                <FormLayout>
                    <TextField
                        value={props.settings.prefix}
                        label="Prefix"
                        placeholder="(Optional) Leave blank if you do not want any prefixes"
                        onChange={onPrefixChange}
                        helpText={
                            <span>
                                Prepend each tag with the prefix value.
                            </span>
                        }
                    />
                    <Select
                        label="Casing Transformation"
                        options={[
                            { label: 'None - use original value', value: 'KeepOriginal' },
                            { label: 'Upper case - uppercase for all letters', value: 'UpperCase' },
                            { label: 'Lower case - lower case for all letters', value: 'LowerCase' },
                            { label: 'Sentence case - lower case for all letters', value: 'SentenceCase' },
                        ]}
                        onChange={onCasingTransformationChange}
                        value={props.settings.casingTransformation}
                        helpText={
                            <span>
                                Keep using the original casing or transform it to upper case, lower case or sentence case.
                            </span>
                        }
                    />
                    <Select
                        label="Spacing Transformation"
                        options={[
                            { label: 'Keep spaces', value: 'KeepSpaces' },
                            { label: 'Use underscores - replace spaces with underscore', value: 'ReplaceWithUnderscores' },
                            { label: 'Use hyphens - replace spaces with hyphens', value: 'ReplaceWithHyphens' },
                        ]}
                        onChange={onSpacesTransformationChange}
                        value={props.settings.spacesTransformation}
                        helpText={
                            <span>
                                Replace spaces with underscores or keep spaces.
                            </span>
                        }
                    />
                </FormLayout>
            </Card.Section>
        </React.Fragment>
    );
}